import React, { useEffect, useState } from 'react';
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';

pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;
const PdfViewer = ({ url, title = 'Documento' }) => {
  const [numPages, setNumPages] = useState(0);
  const [pdf, setPdf] = useState(null);

  useEffect(() => {
    const loadingTask = pdfjsLib.getDocument(url);
    loadingTask.promise.then(loadedPdf => {
      setPdf(loadedPdf);
      setNumPages(loadedPdf.numPages);
    }).catch(err => {
        console.error('Errore nel caricamento PDF:', err);
      });
  }, [url]);

  return (
    <div className="pdf-wrapper">
        {/* Link reale (non un bottone JS) così i motori di ricerca possono scoprire e indicizzare il PDF */}
        <div className="pdf-actions">
            <a href={url} download title={`${title} (PDF)`} className="btn-primary">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <path d="m7 10 5 5 5-5" />
                    <path d="M12 15V3" />
                </svg>
                Scarica PDF
            </a>
        </div>
        <div className="pdf-container">
        {pdf && Array.from({ length: numPages }, (_, index) => (
            <Page key={index} pdf={pdf} pageNumber={index + 1} title={title} />
        ))}
        </div>
    </div>
  );
};

const Page = ({ pdf, pageNumber, title }) => {
    const canvasRef = React.useRef();
    const containerRef = React.useRef();
  
    useEffect(() => {
      const renderPage = async () => {
        const page = await pdf.getPage(pageNumber);
  
        const containerWidth = containerRef.current?.offsetWidth || 600;
        const viewport = page.getViewport({ scale: 0.2 }); // iniziale
        const scale = containerWidth / viewport.width;
        const scaledViewport = page.getViewport({ scale });
  
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');
  
        canvas.height = scaledViewport.height;
        canvas.width = scaledViewport.width;
  
        page.render({
          canvasContext: context,
          viewport: scaledViewport
        });
      };
  
      renderPage();
      window.addEventListener('resize', renderPage);
      return () => window.removeEventListener('resize', renderPage);
    }, [pdf, pageNumber]);
  
    return (
      <div ref={containerRef} className="pdf-page">
        <canvas ref={canvasRef} style={{ width: '100%' }} role="img" aria-label={`${title} – pagina ${pageNumber}`} />
      </div>
    );
  };
  

export default PdfViewer;
